import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PhishingPageAddEdit from './PhishingPageAddEdit';
import './PhishingPageMenu.scss';

export default function PhishingPageMenu(props: any) {
  const { formatMessage } = useIntl();
  const isAdmin = useSelector((state: any) => state.login.userData.isAdmin);
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="phishing-page-menu-wrap">
      <div className="menu-button">
        <button
          className="common-button-brand initial-config-bt"
          type="button"
          onClick={() => setOpenModal(true)}
        >
          {formatMessage({ id: 'Button_10', defaultMessage: '등 록' })}
        </button>
      </div>

      {openModal && (
        <PhishingPageAddEdit
          visible={openModal}
          isAdmin={isAdmin}
          isAddMode
          phishingInfo={{}}
          toggleModal={setOpenModal}
        />
      )}
    </div>
  );
}
